import { Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { ArrowLeft, Home } from "lucide-react";

export default function NotFoundPage() {
  return (
    <Layout>
      <section className="min-h-[60vh] flex items-center justify-center py-20 px-6 bg-[#FBF9F6]" data-testid="not-found">
        <div className="max-w-xl text-center">
          <div className="font-display text-7xl sm:text-8xl font-black text-[#2E4F3B] mb-4 tracking-tight">404</div>
          <h1 className="font-display text-2xl sm:text-3xl font-black text-[#1A1A1A] mb-3">
            Pagina non trovata
          </h1>
          <p className="text-[#5C5C5C] mb-8 leading-relaxed">
            La pagina che stai cercando non esiste o è stata spostata.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              data-testid="not-found-home"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#2E4F3B] hover:bg-[#1f3828] text-white font-bold px-6 py-3 transition-colors"
            >
              <Home className="w-4 h-4" />
              Vai alla Home
            </Link>
            <Link
              to="/contatti"
              className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-[#1A1A1A] text-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-white font-bold px-6 py-3 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Contattaci
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
